import axios from 'axios';
import React, { useMemo } from 'react';
import { isMobile } from 'react-device-detect';
import { AppContext } from '../App';
import './index.scss';
import { InternalOptions } from '../types';

interface PISProps {}

const PIS: React.FC<PISProps> = () => {
  const {
    dispatch,
    amount,
    countryCode,
    currency,
    page,
    successfulExtraction,
    scheme,
    forceDesktop,
    isDonation,
    recipientId,
    customizationName,
  } = React.useContext(AppContext);
  const [error, setError] = React.useState('');
  const internalOptions: InternalOptions = useMemo(() => ({}), []);
  if (forceDesktop) {
    internalOptions.forceDesktop = true;
  }

  React.useEffect(() => {
    if (!amount) {
      setError('A payment amount has not been provided');
      return;
    }
    axios
      .post(
        `${process.env.REACT_APP_SERVER_URL}/token/payment`,
        {
          amount: amount.toFixed(2),
          isMobile,
          countryCode,
          currency,
          scheme,
          isDonation,
          recipientId,
          language: 'en',
          customizationName,
        },
        { withCredentials: true },
      )
      .then((response) => {
        if (response.data.link_token) {
          // @ts-ignore
          let plaidLink = Plaid.create(
            {
              token: response.data.link_token,
              // @ts-ignore
              onSuccess: async (token, metadata) => {
                dispatch({
                  type: 'SET_SUCCESSFUL_EXTRACTION',
                  payload: {
                    successfulExtraction: true,
                  },
                });
              },
              // @ts-ignore
              onExit: async (err, metadata) => {
                // Return to the Landing page for any error or exit event from Link.
                dispatch({
                  type: 'SET_PAGE',
                  payload: {
                    page: 'landing',
                  },
                });
                plaidLink = undefined;
              },
              // @ts-ignore
              onEvent: (eventName, metadata) => {},
            },
            internalOptions,
          );
          plaidLink.open();
          // Change Link's zIndex so the demo banner can be seen
          const iframes = Array.from(document.getElementsByTagName('iframe'));
          iframes.forEach((iframe) => (iframe.style.zIndex = '2147483646'));
        } else {
          setError(response.data.error);
        }
      })
      .catch((error) => {
        setError(error);
      });
  }, [
    dispatch,
    amount,
    countryCode,
    currency,
    page,
    scheme,
    isDonation,
    recipientId,
    customizationName,
    internalOptions,
  ]);

  return (
    <div className="PIS">
      <div className="PIS__title">
        {successfulExtraction && 'Thank you!'}
        {error && 'Error while processing. Please try again'}
      </div>
    </div>
  );
};

export default PIS;
